export const ESTIMATED_COST_CHART_COLOR = {
  monthlyPrice: "#5888FF",
  extraChargePrice: "#CF7171",
  infraUsagePrice: "#F0D36C",
};

export const HISTORY_LIMIT = 10;
